// Navigation des Moduls `ki` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul ki.
import { PlugsConnected, Sparkle } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'ki',
  title: 'Bar AI',
  nav: {
    people: [
      {
        key: 'ki.rail',
        label: 'Bar AI',
        icon: Sparkle,
        path: '/ai/',
        roles: ['ALL'],
        order: 90,
        area: 'rail-bottom',
        external: true,
      },
    ],
    ai: [
      {
        key: 'ki.connect',
        label: 'Connect',
        icon: PlugsConnected,
        path: '/connect',
        roles: ['ALL'],
        order: 70,
        area: 'sidebar',
      },
    ],
  },
});
